<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="$t('uploadWarning.title')"
    :blocking="preventClosing"
    @hide="onDialogHide"
    @close="onOKClick"
  >
    <div class="row q-col-gutter-md">
      <p class="col-12 q-ma-none">
        {{ $t('sessionUploadWarning.message') }}
      </p>
      <div class="col-12 text-center">
        <upload-progress
          color="primary-variant"
          show-always
        />
      </div>
      <div
        v-if="!preventClosing"
        class="col-12"
      >
        <hr-checkbox
          v-model="dontShowAgain"
          :label="$t('sessionUploadWarning.checkboxLabel')"
        />
      </div>
    </div>
    <template
      v-if="!preventClosing"
      #actions
    >
      <hr-dismiss-btn
        :label="$t('common.buttonClose')"
        @click="onOKClick"
      />
    </template>
  </hr-form-dialog>
</template>

<script>
import UploadProgress from 'components/UploadProgress';
import { size } from 'lodash';
import { mapState } from 'pinia';
import {
  HrCheckbox,
  HrDismissBtn,
  HrFormDialog,
} from 'src/design-system';
import { firebaseUploader } from 'src/store/firebaseUploader';

export default {
  name: 'SessionUploadWarning',

  components: {
    HrCheckbox,
    HrDismissBtn,
    HrFormDialog,
    UploadProgress,
  },

  props: {
    preventClosing: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['hide', 'ok'],

  data() {
    return {
      dontShowAgain: false,
    };
  },

  computed: {
    ...mapState(firebaseUploader, ['uploadQueue']),
  },

  watch: {
    uploadQueue: {
      immediate: true,
      deep: true,
      handler(uploadQueue) {
        if (size(uploadQueue) === 0) {
          this.hide();
        }
      },
    },
  },

  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    }, // onDialogHide()

    async onOKClick() {
      if (this.dontShowAgain) {
        localStorage.setItem('dont_show_uploading_warning', true);
      }

      this.$emit('ok');
      this.hide();
    },

  },
};
</script>
